import { useState } from "react";
import { saveCategory, updateCategory } from "../api";
import { Toast } from "src/components";

export const useSaveCategory = ({ companyUuid, close }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [input, setInput] = useState("");
    const [categories, setCategories] = useState({
        companyUuid: companyUuid,
        category: "",
        isGeneral: 1,
        isPremium: 1,
        isUpdatable: "",
    });

    const handleCategory = (category, event) => {
        switch (category) {
            case "categoryTitle":
                const { value } = event.target;
                setCategories((prev) => ({
                    ...prev,
                    category: value,
                }));
            break;
            case "isGeneral":
            case "isPremium":
                setCategories((prev) => ({
                    ...prev,
                    [category]: !prev[category],
                }));
                break;
            default:
        }
    };

    const handleSubmit = async () => {
        const trimmedCategory = categories.category.trim();
        const updatedCategory = trimmedCategory || input;

        setIsSubmitting(true);
        try {
            const manageCategory = categories.isUpdatable ? updateCategory : saveCategory;
            await manageCategory({
                ...categories,
                category: updatedCategory,
            });

            Toast.success(`Category ${categories.isUpdatable ? "updated" : "saved"} successfully.`);
            close();
        } catch (error) {
            console.error(error);
            Toast.error(`Failed to ${categories.isUpdatable ? "update" : "save"} category.`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        setInput,
        isSubmitting,
        categories,
        setCategories,
        setIsSubmitting,
        handleCategory,
        handleSubmit
    };
};